import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  NgModule,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { SystemIconComponentModule } from '@app/shared/ui-components/atoms/icon/icon.component';
import { TableComponent } from '../..';
import { SystemTableService } from '../../services';
import { Subject, takeUntil, tap } from 'rxjs';

@Component({
  selector: 'app-system-sort-icon',
  templateUrl: './sort-icon.component.html',
  styleUrl: './sort-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SortIconComponent implements OnInit, OnDestroy {
  @Input() field: string | undefined;
  sortOrder = 0;

  private destroy$ = new Subject<void>();
  constructor(
    public dt: TableComponent,
    private tableService: SystemTableService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.updateSortState();
    this.tableService.sortSource$
      .pipe(
        takeUntil(this.destroy$),
        tap(() => {
          this.updateSortState();
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateSortState() {
    this.sortOrder = this.dt.isSorted(<string>this.field) ? this.dt.sortOrder : 0;
    this.cd.markForCheck();
  }
}

@NgModule({
  declarations: [SortIconComponent],
  exports: [SortIconComponent],
  imports: [CommonModule, SystemIconComponentModule],
})
export class SystemSortIconModule {}
